import moment, { Moment } from "moment";

export const formatMomentDate = (date: string | Moment | null) => {
    if (!date) return '--';
    if (typeof date === 'string') {
      return moment(date).format('DD MMM, YY');
    }
    return date.format('DD MMM, YY');
  };